import getChatBySessionId from '../selectors/getChatBySessionId';
import type InstantMessagePayload from 'owa-service/lib/contract/InstantMessagePayload';

import { setUserActivity, addChatMessage } from '../actions/ucmaActions';
import { ChatMessageType } from '../store/schema/ChatMessageViewState';

export default function updateUserActivity(notification: InstantMessagePayload) {
    const chat = getChatBySessionId(notification.ChatSessionId);

    if (chat) {
        switch (notification.UserActivity) {
            case 'FailedDelivery':
                addChatMessage(chat, ChatMessageType.FailedDelivery, notification.SipUri);
                break;
            case 'DeliveryTimeout':
                addChatMessage(chat, ChatMessageType.DeliveryTimeout, notification.SipUri);
                break;
            case 'Typing':
            case 'StoppedTyping':
            case 'TwoOrMoreTyping':
                setUserActivity(chat, notification.UserActivity, notification.SipUri);
                break;
        }
    }
}
